// extracted by mini-css-extract-plugin
export var button = "styles-module--button--864b1";
export var cardContainer = "styles-module--cardContainer--93e5e";
export var cardContent = "styles-module--cardContent--c1f73";
export var description = "styles-module--description--04e7f";
export var image = "styles-module--image--d32b9";
export var link = "styles-module--link--b25b0";
export var title = "styles-module--title--03109";